import { StyleSheet } from "react-native";
import { dpToPx, color2 } from "src/styles";
import { font } from "src/styles/themes";

export const styles = () =>
  StyleSheet.create({
    wrapper: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
      paddingLeft: dpToPx(20),
    },

    wrapperInput: {
      marginLeft: dpToPx(8),
    },

    input: {
      color: color2.BLUE_DARK,
      fontFamily: font.family.fromVariable,
      fontSize: font.size.input,
      width: "100%",
    },
  });
